import { usePaginatedApi } from "../../../swr/useApi";
import { adminProductRequestsService } from "../../api_client";
import type { UserProductRequestsDto, ProductRequestQueryDto } from "../../../api";

export function useProductRequestsGroupedByUser(query?: ProductRequestQueryDto) {
    return usePaginatedApi<UserProductRequestsDto, ProductRequestQueryDto>({
        key: "product-requests-grouped-by-user",
        serviceMethod: async (queryParams) => {
            return await adminProductRequestsService.getProductRequestsGroupedByUser(queryParams);
        },
        query: query,
    });
}

